import { FirebaseAnalytics } from '@capacitor-firebase/analytics'
import store from './store'

function withoutEmptyValues(params) {
  const cleaned = {}

  Object.keys(params).forEach(key => {
    if (params[key] !== null && params[key] !== undefined && params[key] !== '') {
      cleaned[key] = params[key]
    }
  })

  return cleaned
}

export function trackEvent(eventName, params) {
  const user = store.state.auth.user || {}
  const allParams = withoutEmptyValues(Object.assign({}, {
    is_native: store.state.app.native ? 1 : 0,
    is_masquerade: (user.is_masquerade || false) ? 1 : 0,
    user_id: user.id || null,
  }, params || {}))

  if (store.state.app.native) {
    FirebaseAnalytics.logEvent({ name: eventName, params: allParams })
    return
  }

  if (typeof window.gtag !== 'function') {
    return
  }

  window.gtag('event', eventName, allParams)
}

export function trackOnlineService(eventName, service, extra) {
  service = service || {}
  const params = Object.assign({
    module: 'online_services',
    service_type: service.serviceType || service.service_type || null,
    service_slug: service.slug || null,
    service_name: (service.name || '').slice(0, 100),
    service_id: (service.id !== undefined && service.id !== null) ? String(service.id) : null,
    service_group: service.group_name || service.group || null,
  }, extra || {})

  trackEvent(eventName, params)
}
